/* ============================================================
   T0'BLACK — FILTER · v3 (navegación editorial)
   Archivo: assets/t0-filter.js

   Barra de navegación premium de la Home (Apple / Nothing):
   - Click en un ítem → scrollIntoView suave a su sección,
     alineada debajo del header (offset configurable).
   - Estado activo SOLO por IntersectionObserver (sin scroll listeners).
   - Nada activo al cargar: se activa según la sección visible.

   Sin filtrado. Sin librerías. Vanilla, mínimo, mantenible.
   ============================================================ */
(function () {
  'use strict';

  var PREFERS_REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qs(selector) { return selector ? document.querySelector(selector) : null; }
  function toArray(nodeList) { return Array.prototype.slice.call(nodeList); }

  /* Controlador de una barra de navegación */
  function NavBar(section) {
    this.section = section;
    this.links = toArray(section.querySelectorAll('.t0-filter__link'));
    this.offset = parseInt(section.dataset.offset, 10) || 0;
    this.bindClicks();
    this.observeSections();
  }

  /* Marca activo un único ítem (o ninguno) */
  NavBar.prototype.setActive = function (link) {
    this.links.forEach(function (l) { l.classList.toggle('is-active', l === link); });
  };

  /* Scroll suave alineado debajo del header */
  NavBar.prototype.scrollToTarget = function (element) {
    if (!element) return;
    element.style.scrollMarginTop = this.offset + 'px';
    element.scrollIntoView({ behavior: PREFERS_REDUCED ? 'auto' : 'smooth', block: 'start' });
  };

  /* Clicks:
     - Ítem de scroll (tiene data-t0-target): scroll suave, sin recarga.
     - Ítem de página (sin data-t0-target): navegación normal del <a href>. */
  NavBar.prototype.bindClicks = function () {
    var self = this;
    this.links.forEach(function (link) {
      if (!link.dataset.t0Target) return; // link a página → dejar navegar
      link.addEventListener('click', function (event) {
        event.preventDefault();
        self.setActive(link);
        self.scrollToTarget(qs(link.dataset.t0Target));
      });
    });
  };

  /* Estado activo por sección visible (IntersectionObserver) */
  NavBar.prototype.observeSections = function () {
    if (!('IntersectionObserver' in window)) return;
    var self = this;

    var watchList = [];
    this.links.forEach(function (link) {
      var el = qs(link.dataset.t0Target);
      if (el) watchList.push({ element: el, link: link });
    });
    if (!watchList.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        for (var i = 0; i < watchList.length; i++) {
          if (watchList[i].element === entry.target) {
            self.setActive(watchList[i].link);
            break;
          }
        }
      });
    }, {
      rootMargin: '-' + (this.offset + 20) + 'px 0px -55% 0px',
      threshold: 0
    });

    watchList.forEach(function (item) { observer.observe(item.element); });
  };

  /* Bootstrap */
  function initAll(root) {
    (root || document).querySelectorAll('[data-t0-filter]').forEach(function (section) {
      if (section.__t0nav) return;
      section.__t0nav = new NavBar(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme Editor
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-t0-filter]')) initAll(e.target);
  });
})();
